import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'
import { capitalizeText } from 'servos/textHelpers'
import Autocomplete from 'react-google-autocomplete';

class GoogleAddress extends React.Component {
  onChange(place) {
    let residentialHistory = {
      locationFullAddress: '',
      locationPostcode: '',
      locationState: '',
      locationAddress: '',
      locationCountry: '',
      locationSuburb: ''
    }

    let addresses = place.address_components
    if (addresses.length > 0) {
      addresses.map((address) => {
        switch(address.types[0]) {
          case 'street_number':
            residentialHistory.locationAddress = address.long_name
            break;
          case 'route':
            residentialHistory.locationAddress =
            residentialHistory.locationAddress.concat(' ' + address.short_name)
            break;
          case 'locality':
            residentialHistory.locationSuburb = address.long_name
            break;
          case 'administrative_area_level_1':
            residentialHistory.locationState = address.short_name
            break;
          case 'country':
            residentialHistory.locationCountry = address.long_name
            break;
          case 'postal_code':
            residentialHistory.locationPostcode = address.long_name
            break;
        }
      })

      this.props.onChange({
        locationFullAddress: null,
        locationPostcode: residentialHistory.locationPostcode,
        locationState: residentialHistory.locationState,
        locationAddress: residentialHistory.locationAddress,
        locationCountry: residentialHistory.locationCountry,
        locationSuburb: residentialHistory.locationSuburb,
      })
    }
  }

  renderLabel = () => {
    const { label } = this.props;
    if (label !== undefined && label.length > 0) {
      return(<label>{label}</label>)
    }
  }

  render() {
    const {
      errorMessage,
      size,
      defaultValue,
      inputGroupClass,
    } = this.props

    return(
      <div className={ `form-group ${ sizes.group[size] } ${ presenceErrorClass(errorMessage) } `}>
        { this.renderLabel() }
        <div className={ `input-group ${inputGroupClass}` } >
        <Autocomplete
          className={`form-control ${ sizes.control[size] } ${ presenceErrorClass(errorMessage) }`}
          defaultValue={this.props.defaultValue}
          onPlaceSelected={(place) => { this.onChange(place) }}
          placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'
          types={['address']}
        />
          <div className="invalid-feedback">
            { errorMessage }
          </div>
        </div>
        <div ref={ el => { this.selectContainer = el }} className='address-select-container' />
      </div>
    )
  }
}

const sizes = {
  group: {
    large: 'form-group-lg',
  },
  control: {
    large: 'form-control-lg',
  }
}

export default GoogleAddress;
